import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import AddIcon from '@mui/icons-material/Add';
import rightarrow from '../../Assets/navbar/right-arrow.svg'
import { useLocation, useNavigate } from "react-router-dom";

// import img6 from '../../Assets/add/img6.png'
import { Alert } from '@mui/material';
import { Box, Calendar, ChevronDown, ChevronUp, FileText, Shield, ShowerHead, Trash, Trash2, Truck, Upload, X } from 'lucide-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import rightArrow from '../../Assets/navbar/right-arrow.svg';
import PersonIcon from '@mui/icons-material/Person';
import Person4Icon from '@mui/icons-material/Person4';
import ApartmentIcon from '@mui/icons-material/Apartment';
import HandshakeIcon from '@mui/icons-material/Handshake';
import { useModal } from "../../context/ModalContext";
import { motion, AnimatePresence } from "framer-motion";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { PDFDocument } from 'pdf-lib';



// import img6 from '../../Assets/home/img4.png'
const config = {
    cUrl: 'https://api.countrystatecity.in/v1/countries/IN',
    ckey: 'NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA=='
};

const SubmitImagesCompanyAdmin = () => {

    const { state } = useLocation();
    const navigate = useNavigate()
    console.log("Received:", state?.mobileNo);
    const userId = localStorage.getItem('userId');
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [isLoadingStates, setIsLoadingStates] = useState(true);
    const [isLoadingCities, setIsLoadingCities] = useState(true);
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
    const [isOpenImage, setIsOpenImage] = useState({});
    const [showVehicleInput, setShowVehicleInput] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [vehicleInputs, setVehicleInputs] = useState([]);
    const [storedVehicleNos, setStoredVehicleNos] = useState([]);
    const [vehicleDetails, setVehicleDetails] = useState({
        vehicleNo: [],

    });
    console.log('vehicleDetails1234', vehicleDetails)

    const [tempVehicleNo, setTempVehicleNo] = useState(""); // temporary input
    const vehicleNoRegex = /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,3}[0-9]{4}$/;
    const [openValidationModal, setOpenValidationModal] = useState(false);

    const [formData, setFormData] = useState({
        loginMobile: '',
        // vehicleNo: [],
        vendorName: localStorage.getItem('vendorName'),
        city: localStorage.getItem('state') || "",
        state: localStorage.getItem('state') || "",
        vendorPhone: localStorage.getItem('vendorPhone'),
        fatherName: '',
        address: localStorage.getItem('address') || '',
        CompanyName: '',
        pincode: ''
    });
    console.log('formdata', formData)
    const [images, setImages] = useState({});

    console.log('images', images)

    const [typeOfAgreement, setTypeOfAgreement] = useState('individual')
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [nextPage, setNextPage] = useState(1);
    const [nextKYCPage, setNextKYCPage] = useState(1);
    console.log('nextpage1234', nextPage)



    useEffect(() => {
        // Scroll to top smoothly when nextPage changes
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [nextPage, nextKYCPage]);

    useEffect(() => {
        if (state?.value !== 'additional-vehicles') {
            localStorage.setItem("typeOfAgreement", typeOfAgreement);
        }
    }, [typeOfAgreement])


    const [imageKeys, setImageKeys] = useState([
        "Photo of the Owner",
        "Adhar Card Front",
        "Adhar Card Back",
        "Pan Card",
        "Cancelled cheque",
        "MOA",
        "Partnership Deed or Company Registration Certificate",
        "GST"


        // ...Array.from({ length: 0 }, (_, i) => `image${i + 1}`),
    ]);

    const [imageKeysForVehicle, setImageKeysForVehicle] = useState([
        'Driver DL',
        "RC",
        "Insurance",
        "Front Vehicle Image",
        "Rear Vehicle Image",
        "Right Side Image",
        "Left Side Image",
    ])

    const [imageKeysIndividual, setImageKeysIndividual] = useState([
        "Photo of the Owner",
        "Adhar Card Front",
        "Adhar Card Back",
        "Pan Card",
        "Cancelled cheque",
        // "RC",
        // "Insurance",
        // "Front Vehicle Image",
        // "Rear Vehicle Image",
        // "Right Side Image",
        // "Left Side Image",
        "GST",


        ...Array.from({ length: 0 }, (_, i) => `image${i + 1}`),
    ]);

    const [isSubmitting, setIsSubmitting] = useState(false);


    useEffect(() => {
        if (formData.vehicleNo?.length) {
            const initialState = {};
            formData.vehicleNo.forEach((v) => {
                initialState[v] = false;
            });
            setIsOpenImage(initialState);
        }
    }, [formData?.vehicleNo, typeOfAgreement]);



    const loadStates = () => {
        setIsLoadingStates(true);
        fetch(`${config.cUrl}/states`, {
            headers: { "X-CSCAPI-KEY": config.ckey }
        })
            .then(response => response.json())
            .then(data => {
                setStates(data);
                setIsLoadingStates(false);
            })
            .catch(error => {
                console.error('Error loading states:', error);
                setIsLoadingStates(false);
            });
    }


    const loadCities = (stateCode) => {

        setIsLoadingCities(true);
        fetch(`${config.cUrl}/states/${stateCode}/cities`, {
            headers: { "X-CSCAPI-KEY": config.ckey }
        })
            .then(response => response.json())
            .then(data => {
                setCities(data);
                setIsLoadingCities(false);
            })
            .catch(error => {
                console.error('Error loading cities:', error);
                setIsLoadingCities(false);
            });
    };

    useEffect(() => {
        if (state?.isFormFilled == false) {
            getStoredData()
        }
        setFormData((prev) => ({
            ...prev,
            vendorName: localStorage.getItem('vendorName'),
            vendorPhone: localStorage.getItem('vendorPhone'),
        }))

    }, [])


    useEffect(() => {
        console.log('state?.mobileNo', state?.mobileNo)
        loadStates();
        if (state?.mobileNo) {
            setFormData(prev => ({
                ...prev,
                login_mobile: state?.mobileNo
            }))
        }
        const hasVisited = sessionStorage.getItem("hasVisitedModal");
        console.log('hasvis', typeof hasVisited, hasVisited)
        console.log('state?.isFormFilled ', state?.isFormFilled, state?.value, hasVisited)
        if (!hasVisited && state?.isFormFilled !== false && state?.value !== 'additional-vehicles') {
            setIsModalOpen(true);
            sessionStorage.setItem("hasVisitedModal", "true");
        }

    }, [state]);

    const convertStateToCode = (state) => {

        if (!state || state.trim() === '') {
            return null
        }

        if (state.toLowerCase() === 'andhra pradesh') {
            return 'AP'
        }
        else if (state.toLowerCase() === 'arunachal pradesh') {
            return 'AR'
        }

        else if (state.toLowerCase() === 'assam') {
            return 'AS'
        }
        else if (state.toLowerCase() === 'bihar') {
            return 'BR'
        }
        else if (state.toLowerCase() === 'chandigarh') {
            return 'CH'
        }
        else if (state.toLowerCase() === 'chattisgarh') {
            return 'CT'
        }

        // TODO:
        else if (state.toLowerCase() === 'dadra and nagar haveli') {
            return 'DH'
        }
        else if (state.toLowerCase() === 'daman and diu') {
            return 'DH'
        }

        else if (state.toLowerCase() === 'delhi') {
            return 'DL'
        }
        else if (state.toLowerCase() === 'goa') {
            return 'GA'
        }
        else if (state.toLowerCase() === 'gujarat') {
            return 'GJ'
        }
        else if (state.toLowerCase() === 'haryana') {
            return 'HR'
        }
        else if (state.toLowerCase() === 'himachal pradesh') {
            return 'HP'
        }
        else if (state.toLowerCase() === 'jammu and kashmir') {
            return 'JK'
        }
        else if (state.toLowerCase() === 'jharkhand') {
            return 'JH'
        }
        else if (state.toLowerCase() === 'karnataka') {
            return 'KA'
        }
        else if (state.toLowerCase() === 'kerala') {
            return 'KL'
        }

        // TODO: LADHAK, LAKSHDWEEP,    

        else if (state.toLowerCase() === 'madhya pradesh') {
            return 'MP'
        }
        else if (state.toLowerCase() === 'maharashtra') {
            return 'MH'
        }
        else if (state.toLowerCase() === 'manipur') {
            return 'MN'
        }
        else if (state.toLowerCase() === 'meghalaya') {
            return 'ML'
        }
        else if (state.toLowerCase() === 'mizoram') {
            return 'MZ'
        }
        // 



        else if (state.toLowerCase() === 'nagaland') {
            return 'HR'
        }
        else if (state.toLowerCase() === 'odisha') {
            return 'HR'
        }
        else if (state.toLowerCase() === 'pondicherry') {
            return 'HR'
        }
        else if (state.toLowerCase() === 'punjab') {
            return 'HR'
        }
        else if (state.toLowerCase() === 'rajasthan') {
            return 'HR'
        }
        else if (state.toLowerCase() === 'sikkim') {
            return 'HR'
        }
        else if (state.toLowerCase() === 'tamil nadu') {
            return 'HR'
        }
        else if (state.toLowerCase() === 'telangana') {
            return 'HR'
        }
        else if (state.toLowerCase() === 'tripura') {
            return 'HR'
        }
        else if (state.toLowerCase() === 'uttar pradesh') {
            return 'HR'
        }
        else if (state.toLowerCase() === 'uttarakhand') {
            return 'HR'
        }
        else if (state.toLowerCase() === 'west Bengal') {
            return 'HR'
        }
        else {
            return null;
        }

    };



    const [pincode, setPincode] = useState('');
    const [locationData, setLocationData] = useState(null);
    const [error, setError] = useState('');

    const handlePincodeChange = async (e) => {

        const value = e.target.value;

        if (value.length === 6) {

            try {

                setIsLoading(true)

                try {
                    const response = await mockPincodeAPI(value);
                    console.log(response)

                    if (response.status) {

                        setFormData((prev) => ({
                            ...prev,
                            state: response.data.data[0].stateName,
                            city: response.data.data[0].cityName,
                        }));
                    }
                }
                catch (error) {
                    openModal({
                        title: 'Error',
                        body: 'Pincode not found. ',
                        iconType: 'error',
                        autoClose: true,
                    });
                }

            } catch (error) {
                openModal({
                    title: 'Error',
                    body: 'Error occurred when fetching pincode.',
                    iconType: 'error',
                    autoClose: true,
                });
            }
            finally {
                setIsLoading(false)
            }
        }
    };

    const mockPincodeAPI = async (pincode) => {

        const response = await axios.get(`http://localhost:3001/api/getDistrictAndState/${pincode}`);
        // const response = await axios.get(`https://onboard.claimpro.in/api/api/getDistrictAndState/${pincode}`);

        return response;
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'state') {
            loadCities(value);
        }

        if (name === "vendorPhone") {
            const digits = value.replace(/\D/g, "");

            // Prevent input beyond 10 digits
            if (digits.length > 10) return;

            setFormData((prev) => ({ ...prev, [name]: digits }));
            return;
        }

        if (name === 'pincode') {
            handlePincodeChange(e)
        }

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };


    const handleAddVehicleNo = () => {
        const newVehicle = tempVehicleNo.trim();
        if (newVehicle && !formData.vehicleNo.includes(newVehicle)) {
            setStoredVehicleNos([...storedVehicleNos, newVehicle]);
            setFormData((prevData) => ({ ...prevData, vehicleNo: [...(prevData.vehicleNo || []), newVehicle] }));
            setTempVehicleNo(""); // clear input
        }
    };

    const MAX_SIZE_MB = 1;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

    const handleImageChange = async (key, file) => {
        if (!file) return;
        console.log('file', file)
        const compressedFile = await compressFile(file);
        console.log('compressedFile', compressedFile)
        setIsSubmitting(true)
        const formData = new FormData();

        formData.append(key, compressedFile);
        // formData.append("key", key);
        formData.append("vendorPhone", localStorage.getItem("vendorPhone"));
        for (let pair of formData.entries()) {
            console.log(`${pair[0]}:`, pair[1]);
        }
        try {
            const res = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/upload-vendor-image/${userId}`,
                formData,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );
            if (res.status === 200) {
                console.log("✅ Image uploaded");
                setImages((prev) => ({ ...prev, [key]: file }));
                setIsSubmitting(false);
            }
        } catch (error) {
            console.error("Image compression error:", error);
            alert("Failed to process image.");

        }
    };



    const [countOfImages, setCountOfImages] = useState(0);
    const [openDeletionModal, setOpenDeletionModal] = useState(false);
    const [deletionVehicle, setDeletionVehicle] = useState(null);

    const deleteVehicle = async (choosenVehicleNo) => {
        const imageKeys = [
            `RC-${choosenVehicleNo}`,
            `Insurance-${choosenVehicleNo}`,
            `Front Vehicle Image-${choosenVehicleNo}`,
            `Rear Vehicle Image-${choosenVehicleNo}`,
            `Left Side Image-${choosenVehicleNo}`,
            `Right Side Image-${choosenVehicleNo}`,
            `Driver DL-${choosenVehicleNo}`
        ];

        const detailKeys = [
            `driverName-${choosenVehicleNo}`,
            `driverNumber-${choosenVehicleNo}`,
            `driverDLNo-${choosenVehicleNo}`,
            `driverDOB-${choosenVehicleNo}`
        ];

        // 🔁 Count how many images exist before deletion
        const currentImages = { ...images };
        const deletedCount = imageKeys.reduce((count, key) => {
            return currentImages[key] ? count + 1 : count;
        }, 0);

        console.log('Deleted image count before update:', deletedCount);

        // 🖼️ Remove images for the chosen vehicle
        setImages((prev) => {
            const updated = { ...prev };
            imageKeys.forEach((key) => delete updated[key]);
            return updated;
        });

        // 🚗 Remove only chosen vehicle's driver details
        setVehicleDetails((prev) => {
            const updated = { ...prev };

            detailKeys.forEach((key) => delete updated[key]);

            // Update vehicleNo list to remove the chosen vehicle
            updated.vehicleNo = (prev.vehicleNo || []).filter(
                (vNo) => vNo && vNo !== choosenVehicleNo
            );

            return updated;
        });

        // Reset UI-related state
        setInputValue('');
        setCountOfImages(deletedCount);

        // If no images were deleted, skip backend call
        if (deletedCount === 0) return;

        // 🧾 Backend DELETE request
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/api/deleteVehicleInfo/${userId}/${choosenVehicleNo}`,
                {
                    headers: { "Content-Type": "application/json" },
                }
            );

            if (res.status === 200) {
                setIsSubmitting(false);
                setCountOfImages(0);
            }
        } catch (error) {
            console.error("Error deleting vehicle data:", error);
            alert("Failed to delete vehicle.");
        }
    };





    // const deleteVehicle = async(choosenVehicleNo) => { 
    //     console.log('choosenVehicleNo', choosenVehicleNo)
    //     console.log('images123', images)
    //     console.log("images[`RC-${choosenVehicleNo}`]", images[`RC-${choosenVehicleNo}`])
    //      const driverName = vehicleDetails[`driverName-${choosenVehicleNo}`];
    //     const driverNumber = vehicleDetails[`driverNumber-${choosenVehicleNo}`];
    //     const driverDLNo = vehicleDetails[`driverDLNo-${choosenVehicleNo}`];
    //     const RC = images[`RC-${choosenVehicleNo}`];
    //     const insurance = images[`Insurance-${choosenVehicleNo}`];
    //     const frontVehicle = images[`Front Vehicle Image-${choosenVehicleNo}`];
    //     const rearVehicle = images[`Rear Vehicle Image-${choosenVehicleNo}`];
    //     const leftVehicle = images[`Left Side Image-${choosenVehicleNo}`];
    //     const rightVehicle = images[`Right Side Image-${choosenVehicleNo}`];



    //     console.log("driverdlno1234",{  choosenVehicleNo, driverName, driverNumber, driverDLNo, RC, insurance, frontVehicle, rearVehicle, leftVehicle, rightVehicle });
    //     const isNotUndefined = [RC, insurance, frontVehicle, rearVehicle, leftVehicle, rightVehicle]
    //     isNotUndefined.forEach((item) => {
    //         if (item !== undefined) {
    //             return true;
    //         }
    //     })
    //     // remove this from vehicleDetails and images whicehver are not undefined object
    //     if (!isNotUndefined) return;
    //     console.log('is not undef')
    //     return;
    //      try {
    //         const res = await axios.put(
    //             `${process.env.REACT_APP_BACKEND_URL}/api/deleteVehicleInfo/${userId}${choosenVehicleNo}`,
    //             formData,
    //             {
    //                 headers: { "Content-Type": "application/json" },
    //             }
    //         );
    //         if (res.status === 200) {
    //             console.log("✅ Image uploaded");
    //             setIsSubmitting(false);
    //         }
    //     } catch (error) {
    //         console.error("Image compression error:", error);
    //         alert("Failed to process image.");
    //     }

    // }




    const handleImageChangeForVehicle = async (key, file) => {
        if (!file) return;
        console.log('file', file)
        const compressedFile = await compressFile(file);
        console.log('compressedFile', compressedFile)
        setIsSubmitting(true);

        console.log('key1232', key)
        const keyStr = key[0]; // 'RC-HR93TS3823'
        const currentVehicleNo = keyStr.split("-")[1]; // 'HR93TS3823'

        const driverName = vehicleDetails[`driverName-${currentVehicleNo}`];
        const driverNumber = vehicleDetails[`driverNumber-${currentVehicleNo}`];
        const driverDLNo = vehicleDetails[`driverDLNo-${currentVehicleNo}`];
        const driverDOB = vehicleDetails[`driverDOB-${currentVehicleNo}`];


        console.log("driverdlno1234", { currentVehicleNo, driverName, driverNumber, driverDLNo });

        const formData = new FormData();
        formData.append(key[0], compressedFile);
        formData.append("vehicleNo", currentVehicleNo);
        formData.append("driverName", driverName);
        formData.append("driverNumber", driverNumber);
        formData.append("driverDLNo", driverDLNo);
        formData.append("driverDOB", driverDOB);
        formData.append("vendorPhone", localStorage.getItem("vendorPhone"));

        for (let pair of formData.entries()) {
            console.log(`${pair[0]}:`, pair[1]);
        }


        // You can now submit `formData` to the backend



        try {
            const res = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/submit-driver-details/${userId}`,
                formData,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );
            if (res.status === 201) {
                console.log("✅ Image uploaded");
                setImages((prev) => ({ ...prev, [key[0]]: file }));
                setIsSubmitting(false);
            }
            else if (res.status === 200) {
                console.log("✅ Image uploaded");
                setImages((prev) => ({ ...prev, [key[0]]: file }));
                setIsSubmitting(false);
            }
        } catch (error) {
            // console.error("Image compression error:", error);
            // alert("Failed to process image.");
            setIsSubmitting(false);
            showError('Vehicle number or mobile number exists already. Please check and try again.');
        }
    };

    const compressFile = (file) => {
        return new Promise(async (resolve, reject) => {
            if (file.type.startsWith("image/")) {
                // 🖼️ Image compression
                const reader = new FileReader();
                reader.onload = (event) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        const scale = Math.min(800 / img.width, 800 / img.height, 1);
                        canvas.width = img.width * scale;
                        canvas.height = img.height * scale;

                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                        canvas.toBlob(
                            (blob) => {
                                if (blob) {
                                    const compressedFile = new File([blob], file.name, { type: file.type });
                                    if (compressedFile.size <= 1024 * 1024) {
                                        resolve(compressedFile);
                                    } else {
                                        showError('Image should be less than 1MB even after compression.');
                                    }
                                } else {
                                    reject(new Error("Compression failed."));
                                    showError("Compression failed.");

                                }
                            },
                            file.type,
                            0.7
                        );
                    };
                    img.onerror = reject;
                    img.src = event.target.result;
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            }

            else if (file.type === "application/pdf") {
                // 📄 Basic PDF recompression using pdf-lib
                try {
                    const existingPdfBytes = await file.arrayBuffer();
                    const pdfDoc = await PDFDocument.load(existingPdfBytes);
                    const compressedPdfBytes = await pdfDoc.save();

                    const compressedFile = new File([compressedPdfBytes], file.name, { type: file.type });

                    if (compressedFile.size <= 1024 * 1024) {
                        resolve(compressedFile);
                    } else {
                        showError('PDF should be less than 1MB even after compression.');
                    }
                } catch (error) {
                    showError('PDF compression failed.');
                }
            }

            else {
                // For other documents
                if (file.size <= 1024 * 1024) {
                    resolve(file);
                } else {
                    reject(new Error("File should be less than 1MB."));
                }
            }
        });
    };

    const [formErrors, setFormErrors] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);


    const requiredFields = ["vendorName", "CompanyName", "fatherName", "vendorPhone", "state", "city", "address", 'pincode'];
    const [missingImages, setMissingImages] = useState([]);
    const [missingFieldsVehicles, setMissingFieldsVehicles] = useState({});


    const handleAddVehicle = () => {
        const newKey = `temp-${Date.now()}`;
        setVehicleInputs([newKey]); // show only one input at a time
        setIsOpenImage({ [newKey]: true }); // open this new section
    };



    const getStoredData = async () => {
        try {
            console.log(`${process.env.REACT_APP_BACKEND_URL}/api/data/${userId}`)
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/getHalfFilledForm/${userId}`
            );
            const fetchedData = response.data;
            console.log('fetched', fetchedData.data)
            // setData(fetchedData.data); // Save raw if needed

            console.log('fetchedData.vehicleNo', fetchedData.data?.driverDLNos)
            console.log('fetchedData.vehicleNo', fetchedData.data?.companyName)

            // Prefill form fields
            setFormData({
                vendorName: fetchedData.data?.vendorName || "",
                vendorPhone: fetchedData.data?.vendorPhone || "",
                fatherName: fetchedData.data?.fatherName || "",
                address: fetchedData.data?.address || "",
                pincode: fetchedData.data?.pincode || "",
                state: fetchedData.data?.state || "",
                city: fetchedData.data?.district || "",
                CompanyName: fetchedData.data?.companyName || "",
                typeOfAgreement: fetchedData.data?.typeOfAgreement,

            });
            setVehicleDetails({
                vehicleNo: fetchedData.data?.vehicleNo?.split(',') || "",
                driverNames: fetchedData.data?.driverNames,
                driverNumbers: fetchedData.data?.driverNumbers,
                driverDLNos: fetchedData.data?.driverDLNos,
                driverDOBs: fetchedData.data?.driverDOBs,

            })

            // Prefill image fields
            const initialImages = {};
            const dynamicKeys = [];
            const defaultKeys = [
                "Photo of the Owner",
                "Adhar Card Front",
                "Adhar Card Back",
                "Pan Card",
                "Cancelled cheque",
                "MOA",
                "Partnership Deed or Company Registration Certificate",
                "GST"
            ];

            if (fetchedData.data?.images) {
                for (const [key, value] of Object.entries(fetchedData.data.images)) {
                    if (value) {
                        initialImages[key] = value;
                        if (!defaultKeys.includes(key)) {
                            dynamicKeys.push(key); // New/unexpected keys
                        }
                    }
                }
            }

            // 3. Combine default and dynamic keys for full display
            const finalKeys = [...defaultKeys, ...dynamicKeys];

            // 4. Update state
            setImages((prev) => ({
                ...prev,
                ...initialImages
            }));
            setImageKeys(finalKeys);

            const formattedImages = {};
            Object.entries(fetchedData.data.vehicleImages).forEach(([vehicleNo, imageObj]) => {
                Object.entries(imageObj).forEach(([key, value]) => {
                    formattedImages[`${key}-${vehicleNo}`] = value;
                });
            });
            setImages(prev => ({ ...prev, ...formattedImages }));
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };



    useEffect(() => {
        if (
            vehicleDetails.driverNames &&
            vehicleDetails.driverNumbers &&
            vehicleDetails.driverDLNos &&
            Array.isArray(vehicleDetails.vehicleNo) &&
            vehicleDetails.vehicleNo.length > 0
        ) {
            const prefilledData = {};
            vehicleDetails.vehicleNo.forEach((vehicle) => {
                prefilledData[`driverName-${vehicle}`] = vehicleDetails.driverNames[vehicle] || "";
                prefilledData[`driverNumber-${vehicle}`] = vehicleDetails.driverNumbers[vehicle] || "";
                prefilledData[`driverDLNo-${vehicle}`] = vehicleDetails.driverDLNos[vehicle] || ""; // 🔧 Fixed key
                prefilledData[`driverDOB-${vehicle}`] = vehicleDetails?.driverDOBs[vehicle] || ""; // 🔧 Fixed key

            });

            setVehicleDetails((prev) => ({
                ...prev,
                ...prefilledData,
            }));
        }
    }, [vehicleDetails.driverNames, vehicleDetails.driverNumbers, vehicleDetails.driverDLNos, vehicleDetails.vehicleNo]);


    const handleVehicleInputChange = (key, value) => {
        setVehicleInputs([value]); // replace temp key with typed value

        // Only add if it’s not already in the list
        if (!formData.vehicleNo.includes(value)) {
            setFormData((prev) => ({
                ...prev,
                vehicleNo: [...prev.vehicleNo, value],
            }));

            // Open the section for this vehicle, close others
            setIsOpenImage({ [value]: true });
        }
    };

    const toggleVehicleImage = (vehicleNo) => {
        setIsOpenImage((prev) => ({
            ...Object.fromEntries(Object.keys(prev).map((k) => [k, false])),
            [vehicleNo]: !prev[vehicleNo],
        }));
    };

    const uploadVendorDetails = async () => {
        // setIsSubmitting(true); // Start loader  
        const updatedFormData = {
            ...formData,
            typeOfAgreement: typeOfAgreement,
        };
        try {
            const res = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/submit-details/${userId}`,
                updatedFormData,
                {
                    headers: { "Content-Type": "application/json" },
                }
            );

            if (res.status === 200) {
                console.log("✅ Submitted:", res.data);
                setNextKYCPage(2)
            }
            else {
                // setAlertInfo({ show: true, message: "File size should be less than 2 MB!", severity: 'error' });
                console.log("❌ Submission failed:", res.data.message);
                // setIsSubmitting(false)
                showSuccessToast(res.data.message)
            }
        } catch (err) {
            console.error("❌ Submit error:", err);
            setAlertInfo({ show: true, message: err.response.data.message, severity: 'error' });
            setIsSubmitting(false); // Stop loader on error too
        }
    }

    useEffect(() => {
        const errors = {};

        for (const field of requiredFields) {
            console.log('filed', field)
            if (typeOfAgreement === 'individual' && field === "companyName" || field === "CompanyName") {
                continue; // Skip validation for individuals
            }
            if (typeOfAgreement !== 'individual' && field === "vehicleNo" || field === "fatherName") {
                continue; // Skip validation for individuals
            }
            if (!formData[field] || (Array.isArray(formData[field]) && formData[field].length === 0)) {
                errors[field] = true;
            }
        }


        if (formData.vendorPhone && formData.vendorPhone.length !== 10) {
            errors.vendorPhone = true;
        }
        if (formData.pincode && formData.pincode.length !== 6) {
            errors.pincode = true;
        }
        setFormErrors(errors);
        setIsFormValid(Object.keys(errors).length === 0);

    }, [formData]);

    const handleContinue = (e) => {
        e.preventDefault();
        const nonRequiredPrefixes = ['image'];
        let requiredKeys, missing;
        if (typeOfAgreement == 'individual' || typeOfAgreement == 'Properiter-Firm') {
            requiredKeys = imageKeysIndividual.filter((key) => key !== "GST" && key !== 'MOA' && key !== "Partnership Deed or Company Registration Certificate" && !nonRequiredPrefixes.some(pre => key.startsWith(pre)));
            missing = requiredKeys.filter((key) => !images[key]);
        }
        else if (typeOfAgreement == 'Partnership-Firm') {
            requiredKeys = imageKeys.filter((key) => key !== "GST" && key !== 'MOA' && !nonRequiredPrefixes.some(pre => key.startsWith(pre)));
            missing = requiredKeys.filter((key) => !images[key]);
        }
        else {
            requiredKeys = imageKeys.filter((key) => key !== "GST" && !nonRequiredPrefixes.some(pre => key.startsWith(pre)));
            missing = requiredKeys.filter((key) => !images[key]);
        }

        if (missing.length > 0) {
            console.log('sodd', missing)
            setMissingImages(missing);
            showError(`Please upload images for: ${missing.join(', ')}`);
            return; // Prevent navigation
        }

        // All required images are uploaded
        setMissingImages([]);
        setNextKYCPage(3);
    };

    const handleAddImageField = () => {
        const newKey = `image${Object.keys(images).length + 1}`;
        setImageKeys((prev) => [...prev, newKey]);
    };

    const handleAddVehicleImageField = () => {
        const newKey = `image${Object.keys(images).length + 1}`;
        setImageKeysForVehicle((prev) => [...prev, newKey]);
    }

    const handleAddImageCompanyField = () => {
        const newKey = `image${Object.keys(images).length + 1}`;
        setImageKeysIndividual((prev) => [...prev, newKey]);
    };

    const showSuccessToast = (e) => {
        toast.success(e);
    };




    const handleContinue2 = (e) => {
        e.preventDefault();
        const requiredKeys = imageKeysIndividual.filter((key) => key !== "GST");
        const missing = requiredKeys.filter((key) => !images[key]);

        if (missing.length > 0) {
            setMissingImages(missing);
            return; // Prevent navigation
        }

        // All required images are uploaded
        setMissingImages([]);

        const isValid = validationCheckFunction();
        if (!isValid) {
            setOpenValidationModal(true);
            return;
        }

        setOpenConfirmationModal(true);
    }

    const readyToSubmit = (e) => {
        e.preventDefault();
        // if (typeOfAgreement !== 'individual') {
        const isValid = validationCheckFunction();
        if (!isValid) {
            setOpenValidationModal(true);
            return;
            // }
        }

        setOpenConfirmationModal(true);
    }



    const validationCheckFunction = () => {
        let newMissingFields = {};
        let firstIncompleteVehicle = null;

        if (vehicleDetails.vehicleNo.length == 0) {
            if (vehicleDetails.vehicleNo.length == 0) {
                setIsSubmitting(false);
                return;
            }
        }
        // if (typeOfAgreement !== 'individual') {
        if (vehicleDetails.vehicleNo.length == 0) {
            setIsSubmitting(false);
            return;
        }

        vehicleDetails.vehicleNo.forEach((vehicleNo) => {
            const driverNameKey = `driverName-${vehicleNo}`;
            const driverNumberKey = `driverNumber-${vehicleNo}`;
            const driverDLNo = `driverDLNo-${vehicleNo}`;
            const driverDOB = `driverDOB-${vehicleNo}`;

            console.log('drivername', driverNameKey)
            console.log('drivername', driverNumberKey)

            const missing = [];

            if (!vehicleDetails[driverNameKey]) missing.push(driverNameKey);
            if (!vehicleDetails[driverNumberKey]) missing.push(driverNumberKey);
            if (!vehicleDetails[driverDLNo]) missing.push(driverDLNo);
            if (!vehicleDetails[driverDOB]) missing.push(driverDOB);



            console.log('fomrad', vehicleDetails[driverNameKey])
            console.log('fomrad', vehicleDetails[driverNumberKey])

            imageKeysForVehicle.forEach((key) => {
                const imageKey = `${key}-${vehicleNo}`;
                if (!images[imageKey]) missing.push(imageKey);
            });

            if (missing.length > 0) {
                newMissingFields[vehicleNo] = missing;
                if (!firstIncompleteVehicle) firstIncompleteVehicle = vehicleNo;
            }
        });

        if (Object.keys(newMissingFields).length > 0) {
            setMissingFieldsVehicles(newMissingFields);
            if (firstIncompleteVehicle) {
                setIsOpenImage({ [firstIncompleteVehicle]: true });
                document.getElementById(`vehicle-section-${firstIncompleteVehicle}`)?.scrollIntoView({ behavior: 'smooth' });
            }
            setIsSubmitting(false); // Start loader

            return false; // Don't submit
        }

        // ✅ All valid
        setMissingFieldsVehicles({});
        console.log('done')
        // navigate('/All-Added-Vehicles')
        // }
        return true;
    }
    const handleSubmit = async (e) => {
        setIsSubmitting(true); // Start loader

        try {
            const res = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/completed-form/${userId}`,
                {
                    headers: { "Content-Type": "application/json" },
                }
            );

            if (res.status === 200) {
                setIsSubmitting(false); // Stop loader
                navigate('/crane-driver-home')
                // setAlertInfo({ show: true, message: "Form Details filled successfully !!!", severity: 'success' });
                showSuccessToast('Form Details filled successfully !!!')
                // setTimeout(() => {
                // }, 3000)

            }
            else {
                // setAlertInfo({ show: true, message: "File size should be less than 2 MB!", severity: 'error' });
                console.log("❌ Submission failed:", res.data.message);
                setIsSubmitting(false)
                showSuccessToast(res.data.message)
            }
        } catch (err) {
            console.error("❌ Submit error:", err);
            setAlertInfo({ show: true, message: err.response.data.message, severity: 'error' });

            setIsSubmitting(false); // Stop loader on error too
        }
    };




    const canAddNewVehicle = () => {
        console.log('vehicleDetails123141', vehicleDetails)
        const lastVehicle = vehicleDetails.vehicleNo[vehicleDetails.vehicleNo.length - 1];
        if (!lastVehicle) return true;

        const driverNameKey = `driverName-${lastVehicle}`;
        const driverNumberKey = `driverNumber-${lastVehicle}`;
        console.log('drivername', driverNameKey)
        console.log('dirvernumber', driverNumberKey)
        if (!vehicleDetails[driverNameKey] || !vehicleDetails[driverNumberKey]) return false;

        for (let key of imageKeysForVehicle) {
            const combinedKey = `${key}-${lastVehicle}`;
            console.log('combinedKey', combinedKey)
            if (!images[combinedKey]) return false;
        }
        return true;
    };

    const [popupMessage, setPopupMessage] = useState('');
    const [showPopup, setShowPopup] = useState(false);

    const showError = (message) => {
        setPopupMessage(message);
        setShowPopup(true);
        setTimeout(() => setShowPopup(false), 3000);
    };

    const fieldMap = {
        vendorName: { htmlFor: 'serviceProviderName', label: 'Service Provider Name' },
        vendorPhone: { htmlFor: 'serviceProviderNumber', label: 'Service Provider Number' },
        CompanyName: { label: 'Company Name' },
        fatherName: { label: "Father's Name" },
        state: { label: 'State' },
        city: { label: 'City' },
        address: { label: 'Address' },
        pincode: { label: 'Pincode' },

    };

    console.log('images12345678', imageKeys)
    const expectedImageKeys = imageKeys.filter((key) => {

        const isIndividualExcluded =
            (typeOfAgreement === "individual" || typeOfAgreement == 'Properiter-Firm') && (key === "MOA" || key === "Partnership Deed or Company Registration Certificate") ||
            typeOfAgreement === "Partnership-Firm" && (key === "MOA");


        const containsVehiclePattern = /-[A-Z]{2}\d{2}[A-Z]{0,2}\d{4}$/.test(key);

        return !isIndividualExcluded && !containsVehiclePattern;
    });


    const [isLoading, setIsLoading] = useState(false);
    const { openModal, modalData, closeModal } = useModal();
    const [showDetails, setShowDetails] = useState(false);
    const showDetailsModalCloseRef = useState(null)
    const [formAdditionalData, setFormAdditionalData] = useState(null)
    const showDetailsRef = useRef(null)

    const response = {
        success: true,
        data: {
            "Vehicle_stautsMessage": "OK",
            "Vehicle_rc_regn_no": "HR46E8144",
            "Vehicle_rc_regn_dt": "08-Oct-2018",
            "Vehicle_rc_regn_upto": "15-Jul-2022",
            "Vehicle_rc_purchase_dt": "16-Apr-2018",
            "Vehicle_rc_owner_sr": "1",
            "Vehicle_rc_owner_name": "S*R K*R",
            "Vehicle_state_cd": "HR",
            "Vehicle_rto_cd": "46",
            "Vehicle_api_response_message": "No response received from AITP API.",
            "Vehicle_rc_present_address": "Rohtak, 124001",
            "Vehicle_rc_permanent_address": "Rohtak, 124001",
            "Vehicle_rc_vch_catg": "LGV",
            "Vehicle_rc_vh_class_desc": "Goods Carrier(LGV)",
            "Vehicle_rc_chasi_no": "MAT505410H0K*",
            "Vehicle_rc_eng_no": "3.8SGI72KSY8*",
            "Vehicle_rc_maker_desc": "TATA MOTORS LTD",
            "Vehicle_rc_maker_model": "TATA SFC 407 CNG / 31 BS-IV",
            "Vehicle_rc_body_type_desc": "RECOVERY VAN",
            "Vehicle_rc_fuel_desc": "CNG ONLY",
            "Vehicle_rc_color": "NA",
            "Vehicle_rc_norms_desc": "BHARAT STAGE IV",
            "Vehicle_rc_fit_upto": "15-Jul-2022",
            "Vehicle_rc_np_upto": "07-Oct-2020",
            "Vehicle_rc_np_issued_by": "Secretary, RTA Rohtak",
            "Vehicle_rc_tax_upto": "31-08-2022",
            "Vehicle_rc_financer": "INDIA INFOLINE FINANCE LTD",
            "Vehicle_rc_insurance_comp": "National Insurance Co. Ltd.",
            "Vehicle_rc_insurance_policy_no": "42060031216360002229",
            "Vehicle_rc_insurance_upto": "04-Jan-2023",
            "Vehicle_rc_manu_month_yr": "10/2017",
            "Vehicle_rc_unld_wt": "2430",
            "Vehicle_rc_gvw": "5550",
            "Vehicle_rc_no_cyl": "4",
            "Vehicle_rc_cubic_cap": "3783.00",
            "Vehicle_rc_seat_cap": "3",
            "Vehicle_rc_sleeper_cap": "0",
            "Vehicle_rc_stand_cap": "0",
            "Vehicle_rc_wheelbase": "3100",
            "Vehicle_rc_registered_at": "RTA, ROHTAK, Haryana",
            "Vehicle_rc_status_as_on": "06-May-2025",
            "Vehicle_rc_pucc_upto": "19-Aug-2022",
            "Vehicle_rc_pucc_no": "HR04600220002561",
            "Vehicle_rc_status": "Fitness Expired",
            "Vehicle_rc_ncrb_status": null,
            "Vehicle_rc_blacklist_status": null,
            "Vehicle_rc_permit_no": "HR/46/NP/LGV/2018/28",
            "Vehicle_rc_permit_issue_dt": "08-Oct-2018",
            "Vehicle_rc_permit_valid_from": "08-Oct-2018",
            "Vehicle_rc_permit_valid_upto": "07-Oct-2023",
            "Vehicle_rc_permit_type": "National Permit [LIGHT GOODS VEHICLE]",
            "Vehicle_rc_permit_code": "106",
            "Vehicle_rc_noc_details": null,
            "Vehicle_rc_vh_type": "T",
            "Vehicle_rc_vh_class": "59",
            "Vehicle_rc_noc_dt": null,
            "Vehicle_rc_fuel_cd": "6",
            "Vehicle_rc_maker_cd": "86",
            "Vehicle_rc_model_cd": "55320831000R",
            "Vehicle_rc_norms_cd": "0",
            "Vehicle_rc_sale_amt": "1020823.0",
            "Vehicle_rc_own_catg_desc": "OTHERS",
            "Vehicle_rc_vch_catg_desc": "LIGHT GOODS VEHICLE",
            "Vehicle_rc_owner_cd_desc": "INDIVIDUAL",
            "Vehicle_rc_vehicle_surrendered_to_dealer": "0",
            "Vehicle_rc_owner_history_offName": null,
            "Vehicle_rc_owner_history_owner_name": null,
            "Vehicle_rc_owner_history_owner_sr": "0",
            "Vehicle_rc_owner_history_stateCd": null,
            "Vehicle_rc_currentadd_districtcode": "0",
            "Vehicle_rc_non_use": "false",
            "Vehicle_rc_passenger_tax": null,
            "Vehicle_rc_goods_tax": null,
            "Vehicle_rc_no_of_axle": "2",
            "Vehicle_rc_qr_url": null,
            "Vehicle_rc_auth_name": null,
            "Vehicle_rc_auth_sign": null,
            "Vehicle_rc_approval_date": null,
            "Vehicle_rc_hp": null,
            "Vehicle_rc_mandal_desc": null,
            "Vehicle_rc_taluk_cd": null,
            "Vehicle_rc_permit_catg": "105",
            "Vehicle_rc_tax_mode": "M",
            "Vehicle_rc_permit_issuing_authority": "RTA, ROHTAK",
            "Vehicle_rc_width": null,
            "Vehicle_rc_fitness_result": null
        }
    };


    const verifyRC = async () => {
        // return
        console.log('Fetching vehicle details: ')

        try {

            // { vh_number: "HR46E8144" },

            setIsLoading(false)

            // const response = await axios.post(
            //     "https://dashboard.traqo.in/api/v1/kyc/verify_rc/",
            //     { vh_number: inputValue },
            //     {
            //         auth: {
            //             username: "9312408268",
            //             password: "9312408268@123",
            //         },
            //         headers: {
            //             "Content-Type": "application/json"
            //         }
            //     }
            // );

            console.log("Response:", response.data);

            if (response?.data && response?.data?.data?.Vehicle_msg === "No data found") {

                openModal({
                    title: 'Error',
                    body: 'No vehicle data found',
                    iconType: 'error',
                    autoClose: true,
                });
                return;
            }

            // Enable below line when calling above API
            // if (response?.data && response?.data?.data?.Vehicle_stautsMessage === 'OK') {
            if (response?.data) {
                console.log("RC Verified:", response.data.data);

                setVehicleDetails((prev) => ({
                    ...prev,
                    vehicleNo: [...prev.vehicleNo, inputValue],
                }));

                setFormData((prevState) => ({
                    ...prevState,
                    engineNo: response.data.Vehicle_rc_eng_no,
                    chassisNo: response.data.Vehicle_rc_chasi_no,
                    make: response.data.Vehicle_rc_maker_desc,
                    model: response.data.Vehicle_rc_maker_model,
                    year: response.data.Vehicle_rc_manu_month_yr?.split('/')[1],
                    GVW: response.data.Vehicle_rc_gvw,
                    InsuranceName: response.data.Vehicle_rc_insurance_comp,
                    InsuranceValidUpto: response.data.Vehicle_rc_insurance_upto,
                    ownerName: response.data.Vehicle_rc_owner_name,
                    ownerAddress: response.data.Vehicle_rc_present_address,
                    state: response.data.Vehicle_state_cd,
                    city: response.data.Vehicle_rc_present_address?.split(',')[0].trim(),
                    pincode: response.data.Vehicle_rc_present_address?.split(',')[1]?.trim(),
                }));

                // setFormAdditionalData({
                //     Vehicle_rc_body_type_desc: response.data.Vehicle_rc_body_type_desc,
                //     Vehicle_rc_regn_no: response.data.Vehicle_rc_regn_no,
                //     Vehicle_rc_owner_name: response.data.Vehicle_rc_owner_name,
                //     Vehicle_rc_permanent_address: response.data.Vehicle_rc_permanent_address,
                //     Vehicle_rc_chasi_no: response.data.Vehicle_rc_chasi_no,
                //     Vehicle_rc_eng_no: response.data.Vehicle_rc_eng_no,
                //     Vehicle_rc_maker_desc: response.data.Vehicle_rc_maker_desc,
                //     Vehicle_rc_maker_model: response.data.Vehicle_rc_maker_model,
                //     Vehicle_rc_fit_upto: response.data.Vehicle_rc_fit_upto,
                //     Vehicle_rc_tax_upto: response.data.Vehicle_rc_tax_upto,
                //     Vehicle_rc_financer: response.data.Vehicle_rc_financer,
                //     Vehicle_rc_insurance_comp: response.data.Vehicle_rc_insurance_comp,
                //     Vehicle_rc_insurance_policy_no: response.data.Vehicle_rc_insurance_policy_no,
                //     Vehicle_rc_insurance_upto: response.data.Vehicle_rc_insurance_upto,
                //     Vehicle_rc_unld_wt: response.data.Vehicle_rc_unld_wt,
                //     Vehicle_rc_gvw: response.data.Vehicle_rc_gvw,
                //     Vehicle_rc_pucc_upto: response.data.Vehicle_rc_pucc_upto,
                //     Vehicle_rc_pucc_no: response.data.Vehicle_rc_pucc_no,
                //     Vehicle_rc_status: response.data.Vehicle_rc_status,
                //     Vehicle_rc_permit_no: response.data.Vehicle_rc_permit_no,
                //     Vehicle_rc_permit_issue_dt: response.data.Vehicle_rc_permit_issue_dt,
                //     Vehicle_rc_permit_valid_upto: response.data.Vehicle_rc_permit_valid_upto,
                // })

                // loadCities(response.data.Vehicle_state_cd);

                // arrowRef.current?.click();

                // setShowDetails(true)

                setIsOpenImage((prev) => ({
                    ...Object.fromEntries(Object.keys(prev).map((k) => [k, false])), // Close all
                    [inputValue]: true, // Open the new one
                }));


            } else {
                console.warn("Verification failed or returned false");
            }


        } catch (error) {
            console.error("Error:", error?.response?.data || error?.message);
            console.log(error?.response?.data?.status)

            if (error?.response?.data?.status) {
                openModal({
                    title: 'Error',
                    body: error?.response?.data?.status,
                    iconType: 'error',
                    autoClose: true,
                });
            }

        }
        finally {
            setIsLoading(false)
        }
    };




    return (
        <div className="bg-white h-[100vh]">

            <div className="flex md:flex-row flex-col justify-center gap-[30px]">
                <div>


                    {isLoading && (
                        <div className="fixed inset-0 z-[9999] bg-gray-100 bg-opacity-80 flex items-center justify-center">
                            <div className="loader2 h-[50px] w-[20px]"></div>
                        </div>
                    )}


                    {/* {typeOfAgreement === "non-individual" && ( */}
                    <div>
                        {nextPage === 1 && (
                            <form className=" font-satoshi max-w-xl mx-auto p-[1.5rem] bg-white rounded-md space-y-4 mb-5 ">



                                <div style={{ background: 'linear-gradient(87deg, #c4c1c1, transparent)' }} className="flex rounded-xl md:flex-row items-center justify-between gap-2 pl-3">
                                    <h2 className="text-xl font-semibold text-center my-2">{nextKYCPage !== 3 ? "KYC" : "Vehicle"} Information</h2>
                                    {/* <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        onClick={() => setIsModalOpen(!isModalOpen)}
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-text-select cursor-pointer"
                                    >
                                        <path d="M14 21h1" /><path d="M14 3h1" />
                                        <path d="M19 3a2 2 0 0 1 2 2" /><path d="M21 14v1" />
                                        <path d="M21 19a2 2 0 0 1-2 2" /><path d="M21 9v1" />
                                        <path d="M3 14v1" /><path d="M3 9v1" />
                                        <path d="M5 21a2 2 0 0 1-2-2" /><path d="M5 3a2 2 0 0 0-2 2" />
                                        <path d="M7 12h10" /><path d="M7 16h6" /><path d="M7 8h8" />
                                        <path d="M9 21h1" /><path d="M9 3h1" />
                                    </svg> */}
                                </div>

                                {/* nextKYCPage == 11 && is old ui in which state, city not aligned in row and two two labels are looking for state */}
                                {nextKYCPage == 11 && (
                                    <div className="mt-5">
                                        {["vendorName", "CompanyName", "fatherName", "vendorPhone", "pincode", "state", "address"]
                                            .filter(
                                                (field) =>
                                                    !(typeOfAgreement === "individual" && field === "CompanyName") &&
                                                    !((typeOfAgreement === "non-individual" || typeOfAgreement == 'Properiter-Firm' || typeOfAgreement === "Partnership-Firm") && field === "fatherName")
                                            )

                                            .map((field) => {
                                                const config = fieldMap[field] || {};
                                                return (
                                                    <div key={field} className="flex flex-col mt-[1rem]">
                                                        <label
                                                            htmlFor={config.htmlFor || field}
                                                            className="mb-1 text-sm font-medium text-gray-700 capitalize font-semibold text-[12px]"
                                                        >
                                                            {(config.label || field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()))}
                                                            <span className="text-red-500 contents"> *</span>
                                                        </label>

                                                        {/* Handle textarea for residence_address */}
                                                        {field === "address" ? (
                                                            <textarea
                                                                id={field}
                                                                name={field}
                                                                value={formData.address || ""}
                                                                placeholder={`Enter ${field.replace(/_/g, " ")}`}
                                                                onChange={handleInputChange}
                                                                className={`border ${formErrors[field] ? "border-red-500" : "border-[#DEDEE8]"} bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full`}

                                                                rows={4}
                                                            />
                                                        ) : field === "vehicleNo" ? (
                                                            <div className="flex flex-col gap-2">
                                                                <div className="flex gap-2">
                                                                    <input
                                                                        id={field}
                                                                        name={field}
                                                                        value={tempVehicleNo}
                                                                        placeholder={`Enter ${field.replace(/_/g, " ")}`}
                                                                        onChange={(e) => setTempVehicleNo(e.target.value.toUpperCase())}
                                                                        className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                                    />
                                                                    <div
                                                                        style={{ background: '#21A6E9' }}
                                                                        className="relative center-button text-white p-2 rounded-full shadow-lg hover:bg-black focus:outline-none mt-2 h-[40px] cursor-pointer"
                                                                        onClick={handleAddVehicleNo}
                                                                    >
                                                                        <AddIcon />
                                                                    </div>
                                                                </div>

                                                                {/* Display all stored vehicle numbers */}
                                                                {formData.vehicleNo.map((vehicleNo, index) => (
                                                                    <div
                                                                        key={index}
                                                                        style={{ background: 'rgb(226 248 255)', border: '1px solid' }}
                                                                        className="relative flex text-black max-w-[45vw] rounded-full px-4 py-2 mb-2 sm:text-[12px] md:text-[15px]"

                                                                    >
                                                                        {vehicleNo}
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => {
                                                                                const updatedVehicleNos = [...formData.vehicleNo];
                                                                                updatedVehicleNos.splice(index, 1);
                                                                                setFormData((prev) => ({
                                                                                    ...prev,
                                                                                    vehicleNo: updatedVehicleNos,
                                                                                }));
                                                                            }}
                                                                            className="absolute top-1 right-2 text-red-600 font-bold hover:text-red-800"
                                                                            title="Remove"
                                                                        >
                                                                            ✕
                                                                        </button>
                                                                    </div>
                                                                ))}

                                                            </div>
                                                        )

                                                            : field === "state" ? (

                                                                <>
                                                                    <div className="flex gap-4 w-full">
                                                                        {/* State */}
                                                                        <div className="flex flex-col w-1/2">
                                                                            <label
                                                                                style={{ display: "inline-block" }}

                                                                                htmlFor="state"
                                                                                className="mb-1 text-sm font-medium text-gray-700 capitalize font-semibold text-[12px]"
                                                                            >
                                                                                State<span className="text-red-500"> *</span>
                                                                            </label>
                                                                            <input
                                                                                id="state"
                                                                                name="state"
                                                                                value={formData.state || ""}
                                                                                onChange={handleInputChange}
                                                                                disabled={isLoadingStates}
                                                                                className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                                            />
                                                                        </div>

                                                                        {/* City */}
                                                                        <div className="flex flex-col w-1/2">
                                                                            <label
                                                                                style={{ display: "inline-block" }}
                                                                                htmlFor="city"
                                                                                className="mb-1 text-sm font-medium text-gray-700 capitalize font-semibold text-[12px]"
                                                                            >
                                                                                City<span className="text-red-500"> *</span>
                                                                            </label>
                                                                            <input
                                                                                id="city"
                                                                                name="city"
                                                                                placeholder="hello"
                                                                                value={formData.city || ""}
                                                                                onChange={handleInputChange}
                                                                                disabled={isLoadingStates}
                                                                                className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                                            />
                                                                        </div>
                                                                    </div>



                                                                </>




                                                            )


                                                                : (
                                                                    // Handle regular input
                                                                    <input
                                                                        id={field}
                                                                        name={field}
                                                                        placeholder={`Enter ${field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}`}
                                                                        value={formData[field] || ""}
                                                                        onChange={(e) => {
                                                                            let value = e.target.value;

                                                                            // Capitalize owner_name and father_name
                                                                            if (["vendorName", "fatherName", "CompanyName"].includes(field)) {
                                                                                value = value.toUpperCase();
                                                                            }

                                                                            // Restrict mobile_no to 10 digits only
                                                                            if (field === "vendorPhone") {
                                                                                value = value.replace(/\D/g, "").slice(0, 10);
                                                                            }
                                                                            if (field === "pincode") {
                                                                                value = value.replace(/\D/g, "").slice(0, 6);
                                                                            }

                                                                            handleInputChange({ target: { name: field, value } });
                                                                        }}
                                                                        readOnly={field === "vendorPhone"}
                                                                        className="border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                                        style={{ padding: "20px" }}
                                                                    />
                                                                )}
                                                    </div>
                                                )
                                            })}
                                        <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                                            <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">

                                                <button
                                                    type="button"
                                                    onClick={() => uploadVendorDetails()}
                                                    // onClick={() => setNextKYCPage(2)}
                                                    disabled={!isFormValid}
                                                    className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full
                                                         ${isFormValid ? "bg-[#21A6E9] hover:bg-[#1e94d6]" : "bg-gray-400 cursor-not-allowed"}`}
                                                >
                                                    Continue
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Next" className="h-[24px] w-[24px]" />
                                                </button>


                                                <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                            </div>
                                        </div>
                                    </div>
                                )}

                                {nextKYCPage == 1 && (
                                    <div className="mt-5">
                                        {["vendorName", "CompanyName", "fatherName", "vendorPhone", "pincode", "state", "address"]
                                            .filter(
                                                (field) =>
                                                    !(typeOfAgreement === "individual" && field === "CompanyName") &&
                                                    !((typeOfAgreement === "non-individual" || typeOfAgreement == 'Properiter-Firm' || typeOfAgreement === "Partnership-Firm") && field === "fatherName")
                                            )

                                            .map((field) => {
                                                const config = fieldMap[field] || {};
                                                return (
                                                    <div key={field} className="flex flex-col mt-[1rem]">
                                                        {/* Don't show generic label for 'state' because it has its own custom layout */}
                                                        {field !== "state" && (
                                                            <label
                                                                htmlFor={config.htmlFor || field}
                                                                className="mb-1 text-sm font-medium text-gray-700 capitalize font-semibold text-[12px]"
                                                            >
                                                                {(config.label || field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()))}
                                                                <span className="text-red-500 contents"> *</span>
                                                            </label>
                                                        )}

                                                        {/* Handle textarea for address */}
                                                        {field === "address" ? (
                                                            <textarea
                                                                id={field}
                                                                name={field}
                                                                value={formData.address || ""}
                                                                placeholder={`Enter ${field.replace(/_/g, " ")}`}
                                                                onChange={handleInputChange}
                                                                className={`border ${formErrors[field] ? "border-red-500" : "border-[#DEDEE8]"} bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full`}
                                                                rows={4}
                                                            />
                                                        ) : field === "vehicleNo" ? (
                                                            <div className="flex flex-col gap-2">
                                                                <div className="flex gap-2">
                                                                    <input
                                                                        id={field}
                                                                        name={field}
                                                                        value={tempVehicleNo}
                                                                        placeholder={`Enter ${field.replace(/_/g, " ")}`}
                                                                        onChange={(e) => setTempVehicleNo(e.target.value.toUpperCase())}
                                                                        className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                                    />
                                                                    <div
                                                                        style={{ background: '#21A6E9' }}
                                                                        className="relative center-button text-white p-2 rounded-full shadow-lg hover:bg-black focus:outline-none mt-2 h-[40px] cursor-pointer"
                                                                        onClick={handleAddVehicleNo}
                                                                    >
                                                                        <AddIcon />
                                                                    </div>
                                                                </div>

                                                                {formData.vehicleNo.map((vehicleNo, index) => (
                                                                    <div
                                                                        key={index}
                                                                        style={{ background: 'rgb(226 248 255)', border: '1px solid' }}
                                                                        className="relative flex text-black max-w-[45vw] rounded-full px-4 py-2 mb-2 sm:text-[12px] md:text-[15px]"
                                                                    >
                                                                        {vehicleNo}
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => {
                                                                                const updatedVehicleNos = [...formData.vehicleNo];
                                                                                updatedVehicleNos.splice(index, 1);
                                                                                setFormData((prev) => ({
                                                                                    ...prev,
                                                                                    vehicleNo: updatedVehicleNos,
                                                                                }));
                                                                            }}
                                                                            className="absolute top-1 right-2 text-red-600 font-bold hover:text-red-800"
                                                                            title="Remove"
                                                                        >
                                                                            ✕
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : field === "state" ? (
                                                            <>
                                                                <div className="flex gap-4 w-full">
                                                                    {/* State */}
                                                                    <div className="flex flex-col w-1/2">
                                                                        <label
                                                                            style={{ display: "inline-block" }}
                                                                            htmlFor="state"
                                                                            className="mb-1 text-sm font-medium text-gray-700 capitalize font-semibold text-[12px]"
                                                                        >
                                                                            State<span className="text-red-500"> *</span>
                                                                        </label>
                                                                        <input
                                                                            id="state"
                                                                            name="state"
                                                                            value={formData.state || ""}
                                                                            onChange={handleInputChange}
                                                                            disabled={isLoadingStates}
                                                                            className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                                        />
                                                                    </div>

                                                                    {/* City */}
                                                                    <div className="flex flex-col w-1/2">
                                                                        <label
                                                                            style={{ display: "inline-block" }}
                                                                            htmlFor="city"
                                                                            className="mb-1 text-sm font-medium text-gray-700 capitalize font-semibold text-[12px]"
                                                                        >
                                                                            City<span className="text-red-500"> *</span>
                                                                        </label>
                                                                        <input
                                                                            id="city"
                                                                            name="city"
                                                                            placeholder="Enter city"
                                                                            value={formData.city || ""}
                                                                            onChange={handleInputChange}
                                                                            disabled={isLoadingStates}
                                                                            className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            // Regular input field
                                                            <input
                                                                id={field}
                                                                name={field}
                                                                placeholder={`Enter ${field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}`}
                                                                value={formData[field] || ""}
                                                                onChange={(e) => {
                                                                    let value = e.target.value;

                                                                    if (["vendorName", "fatherName", "CompanyName"].includes(field)) {
                                                                        value = value.toUpperCase();
                                                                    }

                                                                    if (field === "vendorPhone") {
                                                                        value = value.replace(/\D/g, "").slice(0, 10);
                                                                    }
                                                                    if (field === "pincode") {
                                                                        value = value.replace(/\D/g, "").slice(0, 6);
                                                                    }

                                                                    handleInputChange({ target: { name: field, value } });
                                                                }}
                                                                readOnly={field === "vendorPhone"}
                                                                className="border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                                style={{ padding: "20px" }}
                                                            />
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                                            <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                                <button
                                                    type="button"
                                                    onClick={() => uploadVendorDetails()}
                                                    disabled={!isFormValid}
                                                    className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full
                        ${isFormValid ? "bg-[#21A6E9] hover:bg-[#1e94d6]" : "bg-gray-400 cursor-not-allowed"}`}
                                                >
                                                    Continue
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Next" className="h-[24px] w-[24px]" />
                                                </button>
                                                <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>
                                            </div>
                                        </div>
                                    </div>
                                )}


                                {nextKYCPage == 2 && (
                                    <div>
                                        <div className="flex  md:flex-row items-center justify-between gap-2 p-2">
                                            <h2 className="text-sm font-semibold text-center my-2">UPLOAD KYC IMAGES</h2>
                                        </div>

                                        <div className="overflow-auto grid grid-cols-2 lg:grid-cols-2 gap-[0.7rem]">
                                            {expectedImageKeys.map((key) => (
                                                <div
                                                    key={key}
                                                    style={{
                                                        border: '2px dotted gray',
                                                        ...(missingImages.includes(key) && { border: '2px dotted red' }),
                                                    }}
                                                    className="flex flex-col relative p-[0.2rem] rounded-md rounded-xl"
                                                >
                                                    {images[key] ? (
                                                        <div className="relative w-full h-[6rem] mb-2 rounded-[10%]">
                                                            {typeof images[key] === "object" && images[key] instanceof File ? (
                                                                images[key].type === "application/pdf" ? (
                                                                    <div className="w-full h-[9rem] rounded-xl bg-gray-100 flex flex-col items-center justify-center text-gray-700">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17v-2a2 2 0 012-2h2m4 4v-6a2 2 0 00-2-2h-4l-4 4v6a2 2 0 002 2h4a2 2 0 002-2z" />
                                                                        </svg>
                                                                        <span className="text-sm font-medium">PDF Uploaded</span>
                                                                    </div>
                                                                ) : (
                                                                    <img src={URL.createObjectURL(images[key])} alt={key} className="w-full h-[9rem] rounded-xl object-cover" />
                                                                )
                                                            ) : typeof images[key] === "string" ? (
                                                                images[key].endsWith(".pdf") ? (
                                                                    <div className="w-full h-[9rem] rounded-xl bg-gray-100 flex flex-col items-center justify-center text-gray-700">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17v-2a2 2 0 012-2h2m4 4v-6a2 2 0 00-2-2h-4l-4 4v6a2 2 0 002 2h4a2 2 0 002-2z" />
                                                                        </svg>
                                                                        <span className="text-sm font-medium">PDF Uploaded</span>
                                                                    </div>
                                                                ) : (
                                                                    <img src={images[key]} alt={key} className="w-full h-[9rem] rounded-xl object-cover" />
                                                                )
                                                            ) : null}
                                                            <button
                                                                type="button"
                                                                onClick={() =>
                                                                    setImages((prev) => {
                                                                        const newImages = { ...prev };
                                                                        delete newImages[key];
                                                                        return newImages;
                                                                    })
                                                                }
                                                                className="absolute top-0 right-0 bg-white text-red-900 rounded-full w-9 h-9 flex items-center justify-center text-xs hover:bg-red-600"
                                                                title="Remove Image"
                                                            >
                                                                <Trash2 />
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div className="flex flex-col items-center justify-center mt-[2rem]">
                                                            <button
                                                                type="button"
                                                                style={{ background: 'rgb(140 140 140)' }}
                                                                className="relative center-button text-white p-2 rounded-full shadow-lg hover:bg-black focus:outline-none"
                                                                onClick={() => document.getElementById(`hiddenFileInput-${key}`).click()}
                                                            >
                                                                <AddIcon />
                                                            </button>
                                                            <input
                                                                type="file"
                                                                id={`hiddenFileInput-${key}`}
                                                                accept="image/*,application/pdf"
                                                                onChange={(e) => handleImageChange(key, e.target.files[0])}
                                                                className="form-control text-xs hidden opacity-0"
                                                            />
                                                        </div>
                                                    )}
                                                    <label className="mb-1 text-sm font-medium font-semibold text-[12px] text-gray-700 mt-[1rem] text-center">
                                                        {key}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                        {/* {Object.keys(images).length >= 6 && (
                                            <div className="flex justify-end  mb-4 px-2 py-1">
                                                <button
                                                    type="button"
                                                    onClick={handleAddImageField}
                                                    className="border-2 border-gray-400 bg-white rounded-full px-4 py-2 rounded"
                                                >
                                                    ➕ Add
                                                </button>
                                            </div>)} */}



                                        <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                                            <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                                <button
                                                    onClick={() => setNextKYCPage(1)}
                                                    className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                                >
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px] scale-x-[-1]" />
                                                    Back
                                                </button>
                                                <button
                                                    onClick={handleContinue}
                                                    // onClick={() => setNextPage(3)}

                                                    className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                                bg-[#21A6E9] hover:bg-[#1e94d6]`}
                                                >
                                                    Continue
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px]" />
                                                </button>


                                                <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                            </div>
                                        </div>
                                    </div>
                                )}

                                {nextKYCPage === 3 && (
                                    <form className=" font-satoshi max-w-xl mx-auto bg-white rounded-md space-y-4 mb-5 ">

                                        <div className="flex  md:flex-row items-center justify-between gap-2 p-2">
                                            <h2 className="text-sm font-semibold text-center my-2">ADD VEHICLES</h2>
                                        </div>
                                        {isLoading && (
                                            <div className="fixed inset-0 z-[9999] bg-gray-100 bg-opacity-80 flex items-center justify-center">
                                                <div className="loader2 h-[50px] w-[20px]"></div>
                                            </div>
                                        )}
                                        <div className="mb-[6rem]">
                                            {vehicleDetails.vehicleNo.length === 0 && vehicleInputs.length === 0 && (
                                                <div className="mb-6">
                                                    <p className="text-sm text-black">Enter Vehicle Registration Number</p>
                                                    <div
                                                        className="flex items-center justify-between px-3 py-1 mt-1 rounded"
                                                    >
                                                        <input
                                                            type="text"
                                                            autoFocus
                                                            placeholder="eg. HR11BE1234"
                                                            value={inputValue}
                                                            // onChange={(e) => e.target.value.toUpperCase()}
                                                            onChange={(e) => {

                                                                if (e.target.value.trim() !== '') {
                                                                    // showDetailsRef.current.style.display = "none";
                                                                    showDetailsRef.current.style.display = "block";
                                                                }
                                                                // if (vehicleNoRegex.test(e.target.value)) {
                                                                // }
                                                                // else {
                                                                //     showDetailsRef.current.style.display = "none";
                                                                // }

                                                                setInputValue(e.target.value.toUpperCase())
                                                            }}
                                                            onBlur={(e) => {
                                                                const value = e.target.value.trim().toUpperCase();
                                                                if (vehicleNoRegex.test(value)) {
                                                                    return;
                                                                    setIsOpenImage((prev) => ({
                                                                        ...Object.fromEntries(Object.keys(prev).map((k) => [k, false])), // Close all
                                                                        [value]: true, // Open the new one
                                                                    }));
                                                                    setVehicleDetails((prev) => ({
                                                                        ...prev,
                                                                        vehicleNo: [...prev.vehicleNo, value],
                                                                    }));
                                                                    setIsOpenImage((prev) => ({
                                                                        ...Object.fromEntries(Object.keys(prev).map((k) => [k, false])),
                                                                        [value]: true,
                                                                    }));
                                                                }
                                                            }}
                                                            className="text-sm font-semibold text-black px-2 py-1 rounded w-2/3"
                                                        />

                                                        <div
                                                            style={{ display: 'none' }}
                                                            ref={showDetailsRef}
                                                            onClick={(e) => {
                                                                setIsLoading(true)
                                                                setTimeout(async () => {
                                                                    await verifyRC()

                                                                }, 1000);


                                                            }} className="h-[40px] w-[40px] cursor-pointer rounded-full p-2 bg-[#21A6E9]">
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg'
                                                                alt="arrow"

                                                                onClick={() => toggleVehicleImage('temp')} className="text-green-600" />

                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {[...vehicleDetails.vehicleNo].map((vehicleNo) => (
                                                <div key={vehicleNo} id={`vehicle-section-${vehicleNo}`} className="mb-6">
                                                    <Trash2 className='absolute text-red-500 right-6' onClick={() => {
                                                        setDeletionVehicle(vehicleNo)
                                                        setOpenDeletionModal(true)
                                                    }} />
                                                    <div
                                                        className="flex items-center justify-between  py-1 mt-1 rounded cursor-pointer"
                                                        onClick={() => setIsOpenImage((prev) => ({
                                                            ...Object.fromEntries(Object.keys(prev).map((k) => [k, false])),
                                                            [vehicleNo]: !prev[vehicleNo],
                                                        }))}
                                                    >
                                                        <span className="text-black font-semibold">{vehicleNo}</span>

                                                        <div className="flex gap-2">
                                                            {/* {isOpenImage[vehicleNo] ? (
                                                    <ChevronDown className="text-black h-6 p-1 bg-gray-200 rounded-full" />
                                                ) : (
                                                    <ChevronUp className="text-black h-6 p-1 bg-gray-200 rounded-full" />
                                                )} */}
                                                        </div>
                                                    </div>


                                                    {isOpenImage[vehicleNo] && (
                                                        <div className="mt-2">
                                                            <input
                                                                name={`driverName-${vehicleNo}`}
                                                                value={vehicleDetails[`driverName-${vehicleNo}`] || ""}
                                                                placeholder="Enter Driver Name"
                                                                onChange={(e) => {
                                                                    const { name, value } = e.target;
                                                                    setVehicleDetails((prev) => ({
                                                                        ...prev,
                                                                        [name]: value.replace(/[^a-zA-Z\s]/g, "").slice(0, 50).toUpperCase(),
                                                                    }));
                                                                }}
                                                                className="border border-[#DEDEE8] bg-[#F6F6F6] rounded pl-3 py-2 w-[95%] m-2"
                                                            />
                                                            <input
                                                                name={`driverNumber-${vehicleNo}`}
                                                                value={vehicleDetails[`driverNumber-${vehicleNo}`] || ""}
                                                                placeholder="Enter Driver Mobile Number"
                                                                onChange={(e) => {
                                                                    const { name, value } = e.target;
                                                                    const digitsOnly = value.replace(/\D/g, "").slice(0, 10);

                                                                    // Only update if first digit is 6 or more, or if input is not yet complete
                                                                    if (digitsOnly === "" || digitsOnly[0] >= '6') {
                                                                        setVehicleDetails((prev) => ({
                                                                            ...prev,
                                                                            [name]: digitsOnly,
                                                                        }));
                                                                    }
                                                                }}
                                                                className="border border-[#DEDEE8] bg-[#F6F6F6] rounded pl-3 py-2 w-[95%] m-2"
                                                            />

                                                            <input
                                                                name={`driverDLNo-${vehicleNo}`}
                                                                value={vehicleDetails[`driverDLNo-${vehicleNo}`] || ""}
                                                                placeholder="Enter Driver DL Number"
                                                                onChange={(e) => {
                                                                    const name = e.target.name;
                                                                    const value = e.target.value.toUpperCase();
                                                                    setVehicleDetails((prev) => ({
                                                                        ...prev,
                                                                        [name]: value,
                                                                    }));
                                                                }}
                                                                className="border border-[#DEDEE8] bg-[#F6F6F6] rounded pl-3 py-2 w-[95%] m-2"
                                                            />


                                                            <DatePicker
                                                                selected={
                                                                    vehicleDetails[`driverDOB-${vehicleNo}`]
                                                                        ? new Date(vehicleDetails[`driverDOB-${vehicleNo}`])
                                                                        : null
                                                                }
                                                                onChange={(date) => {
                                                                    const formatted = format(date, 'yyyy-MM-dd');
                                                                    setVehicleDetails((prev) => ({
                                                                        ...prev,
                                                                        [`driverDOB-${vehicleNo}`]: formatted,
                                                                    }));
                                                                }}
                                                                dateFormat="dd/MM/yyyy"
                                                                placeholderText="Enter Driver DOB"
                                                                maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 18))}
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                scrollableYearDropdown
                                                                yearDropdownItemNumber={100} // optional: dropdown will show 100 years
                                                                className="border border-[#DEDEE8] bg-[#F6F6F6] rounded pl-3 w-[95%] py-2 m-2"
                                                            />




                                                            {
                                                                `driverName-${vehicleNo}` in vehicleDetails &&
                                                                `driverNumber-${vehicleNo}` in vehicleDetails &&
                                                                `driverDLNo-${vehicleNo}` in vehicleDetails &&
                                                                `driverDOB-${vehicleNo}` in vehicleDetails &&
                                                                vehicleDetails[`driverName-${vehicleNo}`]?.trim() !== "" &&
                                                                vehicleDetails[`driverNumber-${vehicleNo}`]?.trim() !== "" &&
                                                                vehicleDetails[`driverDLNo-${vehicleNo}`]?.trim() !== "" &&
                                                                vehicleDetails[`driverDOB-${vehicleNo}`]?.trim() !== "" && (
                                                                    <div className="grid grid-cols-2 gap-2 mt-3 p-2 rounded-xl bg-gradient-to-b from-white to-gray-200">
                                                                        {imageKeysForVehicle.map((key) => {
                                                                            const combinedKey = `${key}-${vehicleNo}`;
                                                                            return (
                                                                                <div key={combinedKey} className="flex flex-col relative p-2 rounded-md border-2 border-dotted border-gray-400">
                                                                                    {images[combinedKey] ? (
                                                                                        <div className="relative w-full h-[9rem] mb-2 rounded-md">
                                                                                            {typeof images[combinedKey] === "object" && images[combinedKey] instanceof File ? (
                                                                                                images[combinedKey].type === "application/pdf" ? (
                                                                                                    <div className="w-full h-[9rem] rounded-xl bg-gray-100 flex flex-col items-center justify-center text-gray-700">
                                                                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17v-2a2 2 0 012-2h2m4 4v-6a2 2 0 00-2-2h-4l-4 4v6a2 2 0 002 2h4a2 2 0 002-2z" />
                                                                                                        </svg>
                                                                                                        <span className="text-sm font-medium">PDF Uploaded</span>
                                                                                                    </div>
                                                                                                ) : (
                                                                                                    <img src={URL.createObjectURL(images[combinedKey])} alt={combinedKey} className="w-full h-[9rem] rounded-xl object-cover" />
                                                                                                )
                                                                                            ) : typeof images[combinedKey] === "string" ? (
                                                                                                images[combinedKey].endsWith(".pdf") ? (
                                                                                                    <div className="w-full h-[9rem] rounded-xl bg-gray-100 flex flex-col items-center justify-center text-gray-700">
                                                                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17v-2a2 2 0 012-2h2m4 4v-6a2 2 0 00-2-2h-4l-4 4v6a2 2 0 002 2h4a2 2 0 002-2z" />
                                                                                                        </svg>
                                                                                                        <span className="text-sm font-medium">PDF Uploaded</span>
                                                                                                    </div>
                                                                                                ) : (
                                                                                                    <img src={images[combinedKey]} alt={combinedKey} className="w-full h-[9rem] rounded-xl object-cover" />
                                                                                                )
                                                                                            ) : null}
                                                                                            <button
                                                                                                type="button"
                                                                                                onClick={() =>
                                                                                                    setImages((prev) => {
                                                                                                        const newImages = { ...prev };
                                                                                                        delete newImages[combinedKey];
                                                                                                        return newImages;
                                                                                                    })
                                                                                                }
                                                                                                className="absolute top-0 right-0 bg-white text-red-900 rounded-full w-9 h-9 flex items-center justify-center text-xs hover:bg-red-600"
                                                                                                title="Remove Image"
                                                                                            >
                                                                                                <Trash2 />
                                                                                            </button>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="flex flex-col items-center justify-center h-24">
                                                                                            <button
                                                                                                type="button"
                                                                                                className="bg-gray-600 text-white p-2 rounded-full hover:bg-black"
                                                                                                onClick={() => document.getElementById(`upload-${combinedKey}`).click()}
                                                                                            >
                                                                                                <AddIcon />
                                                                                            </button>
                                                                                            <input
                                                                                                type="file"
                                                                                                id={`upload-${combinedKey}`}
                                                                                                accept="image/*,application/pdf"
                                                                                                className="hidden"
                                                                                                onChange={(e) => handleImageChangeForVehicle([combinedKey], e.target.files[0], inputValue)}
                                                                                            />
                                                                                        </div>
                                                                                    )}
                                                                                    <label className="block text-center text-sm mt-2">
                                                                                        {key} - {vehicleNo}
                                                                                    </label>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>)}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}


                                            {showVehicleInput && (
                                                <div>
                                                    <p className="text-sm text-black mr-3 mt-[2rem] mb-0">Enter Vehicle Registration Number</p>
                                                    <div className="flex items-center justify-between  py-1 mt-1 rounded">
                                                        <input
                                                            type="text"
                                                            autoFocus
                                                            placeholder="eg. HR11BE1234"
                                                            value={inputValue}
                                                            // onChange={(e) => setInputValue(e.target.value.toUpperCase())}
                                                            onChange={(e) => {
                                                                if (e.target.value.trim() !== '') {
                                                                    // showDetailsRef.current.style.display = "none";
                                                                    showDetailsRef.current.style.display = "block";
                                                                }
                                                                setInputValue(e.target.value.toUpperCase())
                                                            }}
                                                            onBlur={(e) => {
                                                                const value = e.target.value.trim().toUpperCase();
                                                                if (vehicleNoRegex.test(value)) {
                                                                    return;
                                                                    setIsOpenImage((prev) => ({
                                                                        ...Object.fromEntries(Object.keys(prev).map((k) => [k, false])), // Close all
                                                                        [value]: true, // Open the new one
                                                                    }));
                                                                    setVehicleDetails((prev) => ({
                                                                        ...prev,
                                                                        vehicleNo: [...prev.vehicleNo, value],
                                                                    }));
                                                                    setIsOpenImage({ [value]: true });
                                                                    setShowVehicleInput(false);
                                                                    setInputValue('');
                                                                }
                                                            }}
                                                            className="text-sm font-semibold text-black px-2 py-1 rounded w-2/3 uppercase"
                                                        />
                                                        {/* <CheckCircleIcon className="text-green-600" /> */}
                                                        <div
                                                            style={{ display: 'none' }}
                                                            ref={showDetailsRef}
                                                            onClick={(e) => {
                                                                setIsLoading(true)
                                                                setTimeout(async () => {
                                                                    await verifyRC()
                                                                    setShowVehicleInput(false); // hide current input
                                                                    setInputValue("");

                                                                }, 1000);


                                                            }} className="h-[40px] w-[40px] cursor-pointer rounded-full p-2 bg-[#21A6E9]">
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg'
                                                                alt="arrow"

                                                                onClick={() => toggleVehicleImage('temp')} className="text-green-600" />

                                                        </div>

                                                    </div>
                                                </div>

                                            )}



                                            {vehicleDetails.vehicleNo.length !== 0 && (
                                                <div className="fixed bottom-[6rem] right-4 z-50">
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            if (!canAddNewVehicle()) {
                                                                showError('Please complete driver info and upload all images before adding a new vehicle.');
                                                                return;
                                                            }
                                                            setShowVehicleInput(true);
                                                            setIsOpenImage({});
                                                            setInputValue('')
                                                        }}
                                                        className=" border-2 border-gray-400 bg-white rounded-full px-4 py-2 rounded"
                                                    >
                                                        ➕ Add More Vehicles
                                                    </button>
                                                </div>)}

                                            {showPopup && (
                                                <div className="fixed top-5 text-center  transform -translate-x-1 bg-red-500 text-white px-4 py-2 rounded shadow z-50">
                                                    {popupMessage}
                                                </div>
                                            )}

                                        </div>

                                        {
                                            alertInfo.show && (
                                                <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                                                    {alertInfo.message}
                                                </Alert>
                                            )
                                        }

                                        <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto" >
                                            <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                                <button
                                                    onClick={() => setNextKYCPage(2)}
                                                    className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                                >
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px] scale-x-[-1]" />
                                                    Back
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={readyToSubmit}
                                                    // disabled={isSubmitting}

                                                    className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                            bg-[#21A6E9] hover:bg-[#1e94d6]`}
                                                >
                                                    {isSubmitting ? (
                                                        <div className="flex gap-2">
                                                            <ClipLoader size={20} color="#ffffff" />
                                                            <p className="mb-0">Submitting...</p>
                                                        </div>
                                                    ) : (
                                                        "Submit"
                                                    )}
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px]" />
                                                </button>

                                                <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                            </div>
                                        </div>
                                    </form>
                                )}


                            </form>
                        )}

                    </div>
                    {/* )} */}



                    {isSubmitting && (
                        <div className="fixed inset-0 z-[9999] bg-gray-100 bg-opacity-80 flex items-center justify-center">
                            <div className="loader2 h-[50px] w-[20px]"></div>
                        </div>
                    )}
                    <Modal
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        setTypeOfAgreement={setTypeOfAgreement}
                        typeOfAgreement={typeOfAgreement}
                    />
                    <ConfirmationModal
                        isOpen={openConfirmationModal}
                        onClose={() => setOpenConfirmationModal(false)}
                        handleSubmit={handleSubmit}
                    />
                    <ConfirmationForDeletion
                        isOpen={openDeletionModal}
                        onClose={() => setOpenDeletionModal(false)}
                        deletionVehicle={deletionVehicle}
                        deleteVehicle={deleteVehicle}
                    />
                    <ValidationFailedModal
                        isOpen={openValidationModal}
                        onClose={() => setOpenValidationModal(false)}
                    />
                </div>
                <div className=' hidden sm:block w-full mt-[5rem] p-5 max-w-[555px]'>
                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/add/img6.png' className='w-[400px] h-[400px]' alt="" />
                </div>
            </div>



            <AnimatePresence>
                {showDetails && (
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 50 }}
                        transition={{ duration: 0.4 }}
                        className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50 flex justify-center items-center"
                        onClick={() => setShowDetails(false)} // Close on outside click
                    >
                        <div
                            className="relative w-[90%] max-w-3xl bg-white rounded-2xl shadow-xl p-6 overflow-y-auto max-h-[90vh]"
                            onClick={(e) => e.stopPropagation()} // Prevent close on inside click
                        >
                            {/* Close Button */}
                            <button
                                onClick={() => setShowDetails(false)}
                                className="absolute top-4 right-4 text-gray-500 hover:text-black transition"
                            >
                                <X size={24} />
                            </button>

                            <h2 className="text-xl font-semibold mb-4 font-satoshi text-[#000]">Vehicle Details</h2>

                            {/* <button ref={showDetailsModalCloseRef} onClick={() => {
                                // alert('i am clicked');
                                setShowDetails(false)
                            }}>click</button> */}

                            <div className="grid grid-cols-2 md:grid-cols-2 gap-4">
                                {/* Chassis No */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                        <span className="flex items-center gap-1">
                                            <FileText size={16} />
                                            Chassis No
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.chassisNo}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>

                                {/* Engine No */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                        <span className="flex items-center gap-1">
                                            <Truck size={16} />
                                            Engine No
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.engineNo}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>

                                {/* Make */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                        <span className="flex items-center gap-1">
                                            <Box size={16} />
                                            Make
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.make}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>

                                {/* Model */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                        <span className="flex items-center gap-1">
                                            <Box size={16} />
                                            Model
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.model}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>

                                {/* Year */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                        <span className="flex items-center gap-1">
                                            <Calendar size={16} />
                                            Year
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.year}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>

                                {/* GVW */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                        <span className="flex items-center gap-1">
                                            <Shield size={16} />
                                            GVW
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.GVW}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>

                                {/* Insurer Name */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000]">
                                        <span className="flex items-center gap-1">
                                            <FileText size={16} />
                                            Insurer Name
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.InsuranceName}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>

                                {/* Insurance Valid Upto */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000]">
                                        <span className="flex items-center gap-1">
                                            <Calendar size={16} className="inline-block mr-1" />
                                            Insurance Valid Upto
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.InsuranceValidUpto}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                )}

            </AnimatePresence>
        </div>
    );
};

export default SubmitImagesCompanyAdmin;


function Modal({ isOpen, onClose, setTypeOfAgreement }) {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
            <div className="bg-white py-[2rem] px-[1rem] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                <h6 className="m-0 font-[500] text-[16px] md:text-[18px] font-satoshi text-center text-[#000000]">Please Choose The Orgnization Type</h6>
                <div className="grid md:grid-cols-2 grid-cols-2 pt-[40px] items-center gap-[18px]">
                    <div
                        onClick={() => {
                            setTypeOfAgreement('individual')
                            onClose();
                        }}

                        className="bg-[rgb(64,125,114)] flex py-[5px] rounded-full pr-[3px] pl-[1rem] w-full justify-center items-center cursor-pointer">
                        <button className="flex font-satoshi gap-2 font-[400] text-[18px] leading-[33.6px] pr-[1rem] text-[#FFFFFF]">
                            <PersonIcon className="mt-1 " />
                            Individual
                        </button>
                        {/* moa , partnership deed  */}
                    </div>
                    <div onClick={() => {
                        setTypeOfAgreement('Properiter-Firm')
                        onClose();
                    }} className="bg-[#21A6E9] flex py-[5px] rounded-full pr-[3px] pl-[1rem] w-full cursor-pointer justify-center items-center">
                        <button className="flex font-satoshi gap-2 font-[400] text-[18px] leading-[33.6px] pr-[1rem] text-[#FFFFFF]">
                            <Person4Icon className="mt-1 " />
                            Properiter
                        </button>
                        {/* gst only */}

                    </div>
                    <div onClick={() => {
                        setTypeOfAgreement('Partnership-Firm')
                        onClose();
                    }} className="bg-[#21A6E9] flex py-[5px] rounded-full pr-[3px]  w-full cursor-pointer justify-center items-center">
                        <button className="flex font-satoshi gap-2 font-[400] text-[18px] leading-[33.6px] pr-[1rem] text-[#FFFFFF]">
                            <HandshakeIcon className="mt-1 " />
                            Partnership
                        </button>
                        {/* partnership deed, gst */}
                    </div>
                    <div onClick={() => {
                        setTypeOfAgreement('non-individual')
                        onClose();
                    }} className="bg-[#21A6E9] flex py-[5px] rounded-full pr-[3px]  w-full cursor-pointer justify-center items-center">
                        <button className="flex font-satoshi gap-2 font-[400] text-[18px] leading-[33.6px] pr-[1rem] text-[#FFFFFF]">
                            <ApartmentIcon className="mt-1 " />
                            Company
                        </button>
                        {/* coi , moa */}
                    </div>


                </div>
            </div>
        </div>
    );
};

function ConfirmationModal({ isOpen, onClose, handleSubmit }) {
    const navigate = useNavigate();
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-center">
                <h2 className="text-lg font-semibold mb-2"> Confirmation of Submission?</h2>
                <p className="text-gray-600 text-sm mb-6">
                    Are you sure you want to submit? You will not be able to change Details later.
                </p>
                <div className="flex justify-around text-sm">
                    <button
                        className="text-gray-700 hover:underline"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="text-blue-600 hover:underline font-medium"
                        onClick={() => {
                            onClose();
                            // navigate('/All-Added-Vehicles');
                            handleSubmit()

                        }}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>)
}


function ConfirmationForDeletion({ isOpen, onClose, deleteVehicle, deletionVehicle }) {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-center">
                <h2 className="text-lg font-semibold mb-2 text-red-500"> Delete Added Vehicle</h2>
                <p className="text-gray-600 text-sm mb-6">
                    Are you sure you want to Delete?
                </p>
                <div className="flex justify-around text-sm">
                    <button
                        className="text-gray-700 hover:underline"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="text-blue-600 hover:underline font-medium"
                        onClick={() => {
                            onClose();
                            deleteVehicle(deletionVehicle)
                        }}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>)
}

function ValidationFailedModal({ isOpen, onClose }) {
    if (!isOpen) return null;

    return (
        <div className="font-satoshi fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-left">
                <p className="text-gray-600 text-sm mb-6">
                    <span className="text-red-600">*</span> Please complete all required fields and upload necessary images before submitting the form.
                </p>
                <div className="flex justify-end">
                    <button
                        className="border-2 border-[#21A6E9] bg-white hover:bg-blue-600  py-1 px-6 rounded"
                        onClick={onClose}
                    >
                        Okay
                    </button>
                </div>
            </div>
        </div>
    );
}




